/**
 * Punto único de carga de los datos data-driven. Al tipar explícitamente
 * cada import contra su interfaz de `core/types.ts`, TypeScript valida en
 * tiempo de compilación que el JSON respeta el contrato (excess property
 * checks incluidos al pasar por una anotación de tipo explícita).
 */

import type { BoardDef, CardDef, ChapterDef, GearDef, UpgradeDef } from '../core/types';

import chaptersJson from './chapters.json';
import cardsJson from './cards.json';
import boardsJson from './boards.json';
import gearJson from './gear.json';
import upgradesJson from './upgrades.json';

export const chapters: ChapterDef[] = chaptersJson as ChapterDef[];
export const cards: CardDef[] = cardsJson as CardDef[];
export const boards: BoardDef[] = boardsJson as BoardDef[];
export const gear: GearDef[] = gearJson as GearDef[];
export const upgrades: UpgradeDef[] = upgradesJson as UpgradeDef[];
